import { DeviceTechProps, PosStatuses } from '@/interfaces/models/pos';
import Pos from '@/models/pos';

type SettingsPosStateProps = {
  status: PosStatuses;
  statusCode?: number;
  posType?: string;
  deviceTech?: DeviceTechProps | null;
};

export default class SettingsPosState {
  public status: PosStatuses;
  public statusCode: number;
  public posType: string;
  public deviceTech: DeviceTechProps | null;

  constructor(posProps: SettingsPosStateProps = SettingsPosState.getDefaultPosProps()) {
    this.status = posProps.status;
    this.statusCode = posProps.statusCode || 0;
    this.posType = posProps.posType || '';
    this.deviceTech = posProps.deviceTech || null;
  }

  public static getDefaultPosProps() {
    return {
      status: 3,
    };
  }

  get isHaveError() {
    return this.status === PosStatuses.UNDEFINED || this.status === PosStatuses.ERROR;
  }

  get isErrorStatus() {
    return this.status === PosStatuses.ERROR;
  }

  get isUndefinedStatus() {
    return this.status === PosStatuses.UNDEFINED;
  }

  get isSuccessStatus() {
    return this.status === PosStatuses.SUCCESS;
  }

  get isWarningStatus() {
    return this.status === PosStatuses.WARNING;
  }

  get isOnline() {
    return !this.isUndefinedStatus;
  }

  get indicatorClass(): string {
    if (this.isHaveError) {
      return 'red';
    }

    return this.isWarningStatus ? 'wrng' : 'ok';
  }

  get problemText(): string {
    if (!this.isErrorStatus && !this.isWarningStatus) {
      return '';
    }

    return Pos.getStatsTextByStatusAndStatusCode(this.status, this.statusCode, this.posType);
  }

  get deviceModel(): string | null {
    if (this.deviceTech === null) {
      return null;
    }

    return [this.deviceTech.manufacturer, this.deviceTech.model]
      .filter((part: string | null): boolean => Boolean(part))
      .join(' ') || null;
  }

  get deviceAppVersion(): string | null {
    return this.deviceTech === null ? null : this.deviceTech.appVersion;
  }

  get deviceWifiSsid(): string | null {
    return this.deviceTech === null ? null : this.deviceTech.wifiSsid;
  }

  get deviceLocalIp(): string | null {
    return this.deviceTech === null ? null : this.deviceTech.localIp;
  }
}
